module.exports = __webpack_public_path__ + "img/payment.87cf7c3e.svg";